import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { tap } from 'rxjs';
import { getColors } from 'src/app/models/colors';
import { Setor } from 'src/app/models/setor';
import { LoadingService } from 'src/app/services/loading.service';
import { ScaleInUseService } from 'src/app/services/scale-in-use.service';
import { TurnoService } from 'src/app/services/turno/turno.service';
import { PopoverSelectColorComponent } from 'src/app/shared/components/popover-select-color/popover-select-color.component';

@Component({
  selector: 'setor-item',
  templateUrl: './setor-item.component.html',
  styleUrls: ['./setor-item.component.scss'],
})
export class SetorItemComponent implements OnInit {

  @Input() isForm!: boolean;
  @Input() Setor!: Setor;
  @Output() FormEmitter: EventEmitter<boolean> = new EventEmitter<boolean>()

  colorSelected = '#1FBAA4'
  active: boolean = true;
  setorName!: string;

  isEdit: boolean = false;
  isSaving = false;

  formGroup!: FormGroup;

  constructor(
    private loadingCtrl: LoadingService,
    private turnoService: TurnoService,
    private popoverCtrl: PopoverController,
    private scaleInUse: ScaleInUseService
  ) { }

  ngOnInit() {
    if (this.Setor) {
      this.active = this.Setor.ativo
      this.colorSelected = this.Setor.cor || '#E54997';
      this.setorName = this.Setor.nome
    }
    if (this.isForm) {
      this.createForm()
    }
  }

  createForm() {
    this.formGroup = new FormGroup({
      nome: new FormControl(this.Setor ? this.Setor.nome : '', [Validators.required]),
      cor: new FormControl(this.Setor ? this.Setor.cor : '#1FBAA4', [Validators.required]),
      idEscala: new FormControl(0),
      ativo: new FormControl(this.Setor ? this.Setor.ativo : true, [Validators.required]),
    })
    this.colorSelected = '#1FBAA4'
    this.scaleInUse.getColorsSelected().pipe(
      tap((usedHexColors) => { // Assuming r (usedHexColors) is now an array of hex strings
        const allSystemHexColors = this.getAllColors(); // this.getAllColors() still calls the updated getColors()
        const availableHexColors = allSystemHexColors.filter(hex => !usedHexColors.includes(hex));
        let colorToUse = '#1FBAA4'; // Default color if none are available or list is empty
        if (availableHexColors.length > 0) {
            colorToUse = availableHexColors[0];
        }
        this.colorSelected = colorToUse;
        if (!this.isEdit) {
          this.formGroup.patchValue({ cor: colorToUse });
        }
      })
    ).subscribe()

    if (this.isEdit) {
      this.colorSelected = this.Setor.cor!;
    }
  }

  getAllColors() {
    return getColors();
  }


  submit() {
    console.log(this.formGroup.value)
    if (this.formGroup.invalid) {
      this.loadingCtrl.presentToast('Por favor, preencha todos os campos.')
      return;
    }
    this.isSaving = true;
    console.log(this.isEdit, 'in edditing')
    if (!this.isEdit) {
      this.turnoService.criaSetor({
        ...this.formGroup.value
      }).pipe(
        tap(() => {
          this.isSaving = false;
          this.loadingCtrl.presentToast('Setor criado com sucesso')
          this.formGroup.reset()
          this.createForm()
          this.isForm = false;
          this.FormEmitter.emit(false);
        })
      ).subscribe()
    } else {
      this.turnoService.atualizarSetor(this.Setor.id, {
        ...this.formGroup.value
      }).pipe(
        tap((res) => {
          this.isSaving = false;
          this.loadingCtrl.presentToast('Setor atualizado com sucesso')
          this.isEdit = false;
          this.isForm = false;
          this.formGroup.reset();
          this.Setor = res;
        })
      ).subscribe()
    }

  }

  setEditMode() {
    this.isEdit = true;
    this.isForm = true;
    this.createForm();
  }

  cancel() {
    if (this.isEdit) {
      this.formGroup.reset();
      this.isEdit = false;
      this.isForm = false;
      return;
    }
    this.formGroup.reset();
    this.createForm();
    this.isForm = false;
    this.FormEmitter.emit(false);
  }

  deleteSetor() {

    this.loadingCtrl.presentAlertConfirm(
      'Deletar Setor?', '', 'Deseja realmente deletar este Setor?',
      () => {
        this.turnoService.deletarSetor(this.Setor.id);
      }
    )
  }

  async openPopover(event: any) {
    const popover = await this.popoverCtrl.create({
      component: PopoverSelectColorComponent,
      side: 'top',
      mode: 'ios',
      event,
      componentProps: {
        scaleId: this.scaleInUse.getEscalaPeriodoId(),
        isSector: true
      }
    })

    popover.present();

    popover.onDidDismiss().then((r) => {
      if (r.data != undefined) {
        this.colorSelected = r.data;
        this.formGroup.patchValue({ cor: r.data })
      }
    })
  }


}
